import { linkFieldsToLinkType, transformIcon } from '@/helpers/transforms'
import type { SubscribeFormBlock as SubscribeFormBlockType } from '@/payload-types'
import type { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import type { CardFeatureIconType } from '../atoms/CardFeatureIcon'
import { SubscribeFormBlock } from '../blocks/SubscribeFormBlock'

export const SubscribeFormConverter: JSXConverter<SerializedBlockNode<SubscribeFormBlockType>> = ({
	node,
}) => {
	const { contactInfo, termsAndConditions } = node.fields

	const itemsData: CardFeatureIconType[] = []

	for (const item of contactInfo ?? []) {
		const { icon, faPrefix, faIcon, title, content, links } = item

		const iconName = faIcon as IconName
		const iconPrefix = faPrefix as IconPrefix
		const linksData = links?.map(linkFieldsToLinkType)

		const itemData: CardFeatureIconType = {
			id: item.id,
			image: transformIcon(icon),
			icon: [iconPrefix, iconName],
			title: title,
			content: content,
			links: linksData,
		}

		itemsData.push(itemData)
	}

	return <SubscribeFormBlock details={itemsData} termsAndConditions={termsAndConditions} />
}
